// extracted by mini-css-extract-plugin
export default {"wrapper":"Efa-z","play":"Ffa-z"};